import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { OrganizationStore } from './+state/organization.store';
import { UserStore } from './+state/user.store';
import { UserService } from './services/user.service';

export function provideUser(): EnvironmentProviders {
  return makeEnvironmentProviders([UserService, UserStore, OrganizationStore]);
}
